import { asset } from '@/lib/assets';

/** '/art/paper.jpg' -> this experience's copy, beside the widget bundle. */
export const art = (path: string): string =>
  asset(`experiences/what-matters-2026${path.startsWith('/') ? path : `/${path}`}`);
